export const LOADING = 'SIGN_LOADING';
export const GET_CERTIFICATES = 'SIGN_GET_CERTIFICATES';
export const SAVE_CERTIFICATES = 'SIGN_SAVE_CERTIFICATES';
export const LIST_SIGNS = 'LIST_SIGNS';
export const POP = 'POP';
export const IS_UNIQUE_ELECTRONIC = 'IS_UNIQUE_ELECTRONIC';
export const LIST_MANUSCRITA = 'LIST_MANUSCRITA';
export const TOKEN_CONNECTION = 'TOKEN_CONNECTION';
